import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon } from '@codex/icons';

const Wrapper = styled.span`
  display: none;
  @media ${(props) => props.theme.breakpoints.mobile} {
    display: block;
    cursor: pointer;
    margin-left: 4px;
  }
`;

const StyledIcon = styled(Icon)`
  color: ${(props) => props.theme.colors.primary.purple};
`;

const MoreInfoButtonMobile = ({ onClick, moreInfoText }) => (
  <Wrapper title={moreInfoText}>
    <StyledIcon
      icon={'Info'}
      onClick={onClick}
    />
  </Wrapper>
);

MoreInfoButtonMobile.propTypes = {
  onClick: PropTypes.func.isRequired,
  moreInfoText: PropTypes.string.isRequired
};

export default MoreInfoButtonMobile;
